module.exports = __webpack_public_path__ + "img/error-img.2bd748ca.svg";